// extracted by mini-css-extract-plugin
module.exports = {"typography":"Typography_typography__3FthS","label":"Typography_label__1G3iF","text":"Typography_text__3IqTs"};